/**
 * @generated SignedSource<<fbd99f28ebe4e86fa96926cd0f36a2f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentType": "SbSharedRelatedItems_user";
};
export type SbSharedRelatedItems_user$key = {
  readonly " $data"?: SbSharedRelatedItems_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedItems_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedItems_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3926354dfdfbdfb44725f005f65f2960";

export default node;
